import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Checkbox, ConfirmDialog, FlashMessage, Input, Modal } from "../../components/common";
import { CircularProgress, Grid } from "@material-ui/core";
import authServices from "../../services/auth.services";
import List from "./components/List";
import _ from "lodash";
import { rootReducersState } from "../../reducers";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { updateCandidateUpdatedDate } from "../../reducers/auth/session.reducer";
import httpRequest from "../../utils/httpRequest";
import API_URLS from "../../utils/apiUrls";
import AppleIcon from '@material-ui/icons/Apple';
import AndroidIcon from '@material-ui/icons/Android';
import CodeEnter from "../../components/common/CodeEnter";
import copyToClipboard from "copy-to-clipboard";
import { ReactComponent as AngleRightBlackIcon } from "../../assets/svg/angle-right-black.svg";
import { ReactComponent as ArrowRightIcon } from "../../assets/svg/arrow-right-pink.svg";


type FormInputs = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  company_logo: string;
  banner_image: string;
  currentPassword1: string;
};

const SecurityLogin = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset: resetForm,
    setError,
    clearErrors,
  } = useForm<FormInputs>();

  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState<boolean>(false);
  const [viewAllSessions, setViewAllSessions] = useState<boolean>(false);
  const [sessionData, setSessionData] = useState<Array<object>>([]);
  const [currentlySigned, setCurrentlySigned] = useState<number>(0);
  const [sessionId, setSessionId] = useState<string>("");
  const [password, setPassword] = useState<boolean>(false);

  const [openModel, setOpenModel] = useState<boolean>(false);
  const [qrCodeURL, setQrCodeURL] = useState('');
  const [inputValues, setInputValues] = useState(Array(6).fill(''));
  const [verifyError, setVerifyError] = useState('');
  const [clearFlag, setClearFlag] = useState(false);
  const [passError, setPassError] = useState('');
  const [confirmDisable, setConfirmDisable] = useState(false);
  const [haveTwoFA, setTwoFA] = useState(false);
  const [recoveryModal, setRecoveryModal] = useState(false);
  const [recoverSecret, setRecoverySecret] = useState("");
  const [option, setOption] = useState("");
  const [OpenCreateKeyModal, setOpenCreateKeyModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordAccordionOpen, setIsPasswordAccordionOpen] = useState(false);
  const [isTwoStepVerificationAccordionOpen, setIsTwoStepVerificationAccordionOpen] = useState(false);
  const {
    handleSubmit: handlePasswordSubmit,
    register: registerPassword,
    formState: { errors: errorsPassword },
  } = useForm({});

  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session.currentUser
  );

  useEffect(() => {
    fetchUserSessions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUserSessions = async () => {
    try {
      const sessionsData = await authServices.getUserSessions();

      const sessionData = _.get(sessionsData, "data.rows", []);
      const activeCount = sessionData.filter(
        (session: { active_session?: number }) => session?.active_session === 1
      ).length;
      setCurrentlySigned(activeCount);
      setTwoFA(sessionReducer.twofa_enable);
      setSessionData(sessionData);
    } catch (error) {
      FlashMessage(_.get(error, "message"), "error");
    }
  };

  const currentMatchingPassword = watch("newPassword", "");
  const currentPassword1 = watch("currentPassword1")

  const _handleClosePasswordChangeModal = () => {
    resetForm({});
  };

  const handleChange = () => {
    setSelectedValue(!!!selectedValue);
  };

  const onSubmit = async (formData: FormInputs) => {
    try {
      const resp = await authServices.changePassword({
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
        confirmPassword: formData.confirmPassword,
        requireAll: selectedValue,
      });

      if (resp.flag) {
        FlashMessage(_.get(resp, "message"), "success");
        setSelectedValue(false);
        const currentDate = moment().format("YYYY-MM-DD hh:mm:ss");
        dispatch(updateCandidateUpdatedDate(currentDate));
        resetForm({});
        if (selectedValue) {
          await filterSessions(_.get(resp, "data"));
        }
      } else {
        const respErrors = (resp as { errors?: Record<string, string> }).errors || {};
        const errorMessages = Object.values(respErrors);
        if (errorMessages.length > 0) {
          FlashMessage(errorMessages[0], "error");
        } else {
          FlashMessage(_.get(resp, "message", "Unable to change password"), "error");
        }
        if (respErrors.newPassword) {
          setError("newPassword", {
            type: "server",
            message: respErrors.newPassword,
          });
        }
        if (respErrors.currentPassword) {
          setError("currentPassword", {
            type: "server",
            message: respErrors.currentPassword,
          });
        }
      }
    } catch (error) {
      const errMessage =
        _.get(error, "response.data.message") ||
        _.get(error, "message") ||
        "Unable to change password";
      FlashMessage(errMessage, "error");
    }
  };

  const filterSessions = (id) => {
    sessionData.forEach((item) => {
      if (_.get(item, "id") !== id) {
        item["active_session"] = 0;
      }
    });

    setSessionData(sessionData);
  };

  const handleLogout = (id) => {
    setSessionId(id);
    setPassword(true);
  };

  const passwordSubmit = async (formData) => {

    try {
      const resp = await authServices.updateSession({
        sessionId: sessionId,
        password: _.get(formData, "currentPassword", ""),
      });

      if (resp.flag) {
        FlashMessage(_.get(resp, "message"), "success");
        setPassword(false);

        await filterSessionsData(sessionId);
      } else {
        FlashMessage(_.get(resp, "message"), "error");
      }
    } catch (error) {
      FlashMessage(_.get(error, "message"), "error");
    }
  };

  const filterSessionsData = (id) => {
    sessionData.forEach((item) => {
      if (_.get(item, "id") === id) {
        item["active_session"] = 0;
      }
    });

    setSessionData(sessionData);
  };

  const handleTwoStepVerification = async () => {
    setPassError("");
    if (!currentPassword1?.trim()) {
      setError("currentPassword1", {
        type: "required",
        message: "Please enter current password",
      });
      return;
    }
    clearErrors("currentPassword1");
    try {
      const payload = {
        password: currentPassword1,
      };
      const data = await httpRequest().post(API_URLS.verifyPassword, payload);
      if (data.data.isValid) {
        setOpenModel(true);
        twoStepVerification();
        setClearFlag(false);
      } else {
        setPassError("Incorrect password.");
      }
    } catch (error: any) {
      FlashMessage(
        _.get(error, "response.data.message") || _.get(error, "message") || "Something went wrong",
        "error"
      );
    }
  };

  const twoStepVerification = async () => {
    setIsLoading(true);
    try {
      const data = await httpRequest().post(API_URLS.twoStepVerification);
      setQrCodeURL(data.data.data);
    } catch (error) {
      FlashMessage(error, "error")
    } finally {
      setIsLoading(false)
    }

  }

  const verifyToken = async () => {
    try {
      if (!inputValues.includes('')) {

        const verifyCode = [...inputValues].join('')
        const payload = {
          token: verifyCode,
          id: sessionReducer?.id
        }
        const data = await httpRequest().post(API_URLS.verifyToken, payload);

        if (data.data.data.delta === 0) {
          handleClose();
          generateRecovery();
          setRecoveryModal(true);
          setTwoFA(true)
        } else {
          setVerifyError('Enter valid verification code')
        }
      } else {
        setVerifyError("Please enter 6 digit verification code")
      }
    } catch (error) {
      FlashMessage(error, "error")
    }
  }

  const handleClose = () => {
    setOpenModel(false)
    setQrCodeURL('')
    setClearFlag(true)
    setVerifyError('')
  };

  const handleInputChange = (index, value) => {
    if (value.length === 1) {
      setInputValues(prevValues => {
        const newValues = [...prevValues];
        newValues[index] = value;
        return newValues;
      });
    }
  };

  const handleDisableTwoFA = async () => {
    const data = await httpRequest().put(API_URLS.disableTwoFA);
    if (data.data.message === "Success") {
      setConfirmDisable(false)
      setTwoFA(false)
    } else {
      FlashMessage("something wrong", "error")
    }
  }

  const generateRecovery = async () => {
    try {
      const data = await httpRequest().put(API_URLS.recoveryGenerate);
      if (data.data.status === 200) {
        const recoveryKey = data.data.data.recovery_secret
        setRecoverySecret(recoveryKey)
      }
    } catch (error) {
      FlashMessage(error.message, "error")
    }
  }

  const _copyRecoveryKey = () => {
    copyToClipboard(recoverSecret);
    setOption("copy");
    FlashMessage("Recovery key copied to clipboard", "success");
  };

  const handlePrint = () => {
    window.print()
  }

  useEffect(() => {
    if (!inputValues.includes('') && inputValues.length === 6) {
      verifyToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValues])

  useEffect(() => {
    if (recoveryModal) {
      setOption("");
    }
  }, [recoveryModal]);

  return (
    <div className="profile-container">
      <div className="settings-header">
        <h3>Password and Security</h3>
        <p className="font-md">Let’s make your account more secure.</p>
          <p className="font-md">
            We’ re always working on ways to increase safety in our employHer.
            That’s why we look at every account to make sure it’s as secure as
            possible.
          </p>
          <p className="font-md">You account security : Low</p>
      </div>
      <div>

        <div className="settings-header">
          <h3>Login & Recovery</h3>
          <p className="font-md">Manage your passwords, login preferences and recovery methods.</p>
        </div>

        <div className="settings-accordion-wrapper">
          <div className="accordion-item">
            <div className="accordion-header" onClick={() => setIsPasswordAccordionOpen(!isPasswordAccordionOpen)}>
              <h5>Change Password</h5>
              <div className={`angle-icon ${isPasswordAccordionOpen ? 'open' : ''}`}>
                <AngleRightBlackIcon />
              </div>
            </div>
            {
              isPasswordAccordionOpen && (
                <div className="accordion-content">
                  <form noValidate onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={3}>
                      <Grid item sm={12} xs={12}>
                        <Grid item sm={6} xs={12}>
                          <Input
                            type="password"
                            externalLabel={{ label: "Current password" }}
                            placeholder="Current password"
                            validationObj={errors}
                            {...register("currentPassword", {
                              required: {
                                value: true,
                                message: "Please enter current password",
                              },
                            })}
                            className="settings-input"
                          />
                        </Grid>
                      </Grid>
                      <Grid item sm={6} xs={12} className="pb-0">
                        <Input
                          // name="newPassword"
                          type="password"
                          externalLabel={{ label: "New password" }}
                          placeholder="New password"
                          validationObj={errors}
                          // inputRef={register({
                          //   required: {
                          //     value: true,
                          //     message: "Please enter new password",
                          //   },
                          //   pattern: {
                          //     value:
                          //       /^(?=.*[a-z])(?!.* )(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
                          //     message:
                          //       "Must content at least one upper case, lower case, digit, special character and no white space",
                          //   },
                          // })}

                          {...register("newPassword", {
                            required: {
                              value: true,
                              message: "Please enter new password",
                            },
                            pattern: {
                              value:
                                /^(?=.*[a-z])(?!.* )(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
                              message:
                                "Must content at least one upper case, lower case, digit, special character and no white space",
                            },
                          })}
                          className="settings-input"
                        />
                      </Grid>
                      <Grid item sm={6} xs={12} className="pb-0">
                        <Input
                          // name="confirmPassword"
                          type="password"
                          externalLabel={{ label: "Confirm password" }}
                          placeholder="Confirm password"
                          validationObj={errors}
                          // inputRef={register({
                          //   required: {
                          //     value: true,
                          //     message: "Please enter confirm password",
                          //   },
                          //   validate: (value) =>
                          //     value === currentMatchingPassword ||
                          //     "The re-entered do not match",
                          // })}
                          {...register("confirmPassword", {
                            required: {
                              value: true,
                              message: "Please enter confirm password",
                            },
                            validate: (value) =>
                              value === currentMatchingPassword ||
                              "The re-entered do not match",
                          })}
                          className="settings-input"
                        />
                      </Grid>

                      <Grid item sm={12} xs={12}>
                        <Checkbox
                          checked={selectedValue}
                          onClick={(e) => {
                            handleChange();
                          }}

                          externalLabel={{
                            label: "Require all devices to sign in with new password",
                          }}
                        />
                      </Grid>
                    </Grid>
                    <div className="action-wrapper change-password-wrapper">
                      <Button
                        onClick={() => _handleClosePasswordChangeModal()}
                        color="secondary"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"

                      >
                        Change Password
                      </Button>
                    </div>
                  </form>
                </div>
              )
            }
          </div>

          <div className="accordion-item">
            <div className="accordion-header" onClick={() => setIsTwoStepVerificationAccordionOpen(!isTwoStepVerificationAccordionOpen)}>
              <h5>Two-Factor Authentication</h5>
              <div className={`angle-icon ${isTwoStepVerificationAccordionOpen ? 'open' : ''}`}>
                <AngleRightBlackIcon />
              </div>
            </div>
            {
              isTwoStepVerificationAccordionOpen && (
                <div className="accordion-content">
                  {/* disable two step verification */}
                  {haveTwoFA ? (
                    <>
                      <div className="settings-header">
                        <h5>Create a new Emergency Key</h5>
                        <p className="font-md">
                          Once you create a new key existing Emergency Recovery key will expire.
                        </p>
                      </div>
                      <div className="disable-twoFA" >
                        <Button color="primary" onClick={() => setOpenCreateKeyModal(true)}>Create Key</Button>
                      </div>

                      <div className="settings-header">
                        <h3>Disable two-step verification</h3>
                        <p className="font-md">
                          If you are disable two-step verification , Your account will no longer have the protection
                          of a second login setup.
                        </p>
                      </div>
                      <div className="disable-twoFA" >
                        <Button color="primary" onClick={() => setConfirmDisable(true)}>Disable</Button>
                      </div>
                      <ConfirmDialog
                        title="Disable Two Step Authentication"
                        visible={confirmDisable}
                        bodyText="Are you sure want to Disable Two step verification?"
                        onConfirm={() => handleDisableTwoFA()}
                        onCancel={() => setConfirmDisable(false)}
                      />
                    </>
                  ) : (
                    <>
                      <div className="settings-header">
                        <h5>Set up two-step verification</h5>
                        <p className="font-md">
                          To setting up two-step verification you must have to remember your
                          profile current password, by entering current password you can guide
                          to enable two-step verification.
                        </p>
                      </div>
                      <div className="pb-10">
                        <Grid item sm={6} xs={12} className="pb-0 verification-wrapper">
                          <Input
                            type="password"
                            externalLabel={{ label: "Current password" }}
                            placeholder="Current password"
                            validationObj={errors}
                            className="settings-input"
                            {...register("currentPassword1")}
                          />
                          {
                            passError && (
                              <span className="text-sm text-danger error-helper ml-14">
                                {passError}
                              </span>
                            )
                          }
                        </Grid>
                      </div>

                      <div className="action-wrapper">
                        <Button type="submit" color="primary" onClick={() => handleTwoStepVerification()}>
                          Next
                        </Button>
                        <Button
                          onClick={() => _handleClosePasswordChangeModal()}
                          color="secondary"
                        >
                          Cancel
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              )
            }
          </div>
        </div>

        <div className="pt-10">

        </div>
      </div>
      <div className="security-check-wrapper">
        <div className="security-check-header">
          <div className="settings-header">
            <h3>Security Check </h3>
            <p className="font-md">Manage security alerts across your apps, devices, and email activity.</p>
            <p className="font-md font-bold-600">You’re currently signed in to {currentlySigned} session.</p>

          </div>
          <div className="outline-btn-wrapper">
            <Button
              variant="text"
              onClick={() => {
                setViewAllSessions(true);
              }}
            >
              <span className="btn-content">View All</span>
              <ArrowRightIcon />
            </Button>
          </div>
        </div>
        <List
          data={sessionData}
          size={2}
          handleLogout={(e) => {
            handleLogout(e);
          }}
        />
      </div >
      <Modal
        title="Sessions"
        visible={viewAllSessions}
        className="profile-modal editable-profile-modal"
        onClose={() => setViewAllSessions(false)}
      >
        <List
          data={sessionData}
          size={sessionData.length}
          handleLogout={(e) => {
            handleLogout(e);
          }}
        />
      </Modal>
      <Modal
        title="Password"
        visible={password}
        className="change-pw-modal"
        onClose={() => setPassword(false)}
      >
        <div>
          <form noValidate onSubmit={handlePasswordSubmit(passwordSubmit)}>
            <Grid container spacing={3}>
              <Grid item xs={12} className="pb-0">
                <Input
                  // name="currentPassword"
                  type="password"
                  externalLabel={{ label: "Current password" }}
                  placeholder="Current password"
                  validationObj={errorsPassword}
                  // inputRef={registerPassword({
                  //   required: {
                  //     value: true,
                  //     message: "Please enter current password",
                  //   },
                  // })}
                  {...registerPassword("currentPassword", {
                    required: {
                      value: true,
                      message: "Please enter current password",
                    },
                  })}
                />
              </Grid>

              <Grid item xs={12} className="text-right form-actions">
                <Button
                  onClick={() => setPassword(false)}
                  color="secondary"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  color="primary"
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Modal>

      {/* twoFA scanner modal */}
      {openModel && (
        <Modal
          title="Set Up Two-Step Verification"
          className="two-Step-verification"
          visible={openModel}
          size="large"
          onClose={() => handleClose()}
        >
          <div className="follow-step">Please follow the step below to set up two-step verification </div>
          <div className="steps-auth"><span>Step 1: </span>Download two step verification app</div>
          <div className="follow-step link-url"><AppleIcon color="primary" />iPhone devices:
            <a href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458" target="_blank" rel="noreferrer"
            >Google Authenticator</a> </div>
          <div className="follow-step link-url"><AndroidIcon color="primary" />Android devices:
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en_IN" rel="noreferrer">Google Authenticator</a>
          </div>
          <div className="steps-auth"><span>Step 2: </span>Scan this QR code with your verification app</div>

          {isLoading ? (
            <div className="image-container">
              <CircularProgress color="secondary" className="circular-progress" />
            </div>
          ) : (
            qrCodeURL && (
              <div className="image-container">
                <img className="qr-img" alt="QR code" src={qrCodeURL}></img>
              </div>
            )
          )}

          <div className="steps-auth"><span>Step 3: </span>Enter the resulting of verification code</div>
          <div className="follow-step">Enter 6-digit code verification code generated by authentication app. </div>
          <div className="enter-code">
            <CodeEnter
              clear={clearFlag}
              handleOnChange={(index, e) => handleInputChange(index, e.target.value)}
            />
          </div>
          <div className="code-error">
            {verifyError && (
              <span className="text-sm text-danger error-helper">
                {verifyError}
              </span>
            )}
          </div>
          <Button
            className="verify-btn"
            onClick={() => verifyToken()}
          >Verify Code</Button>
        </Modal>
      )}


      {/* secret key */}
      {recoveryModal && (
        <Modal
          title="Save Recovery Key"
          className="recovery-modal"
          visible={recoveryModal}
          size="large"
          closeOnBackDrop={false}
          onClose={() => setRecoveryModal(false)}
        >
          <div className="recovery-modal-content">
            <div className="recovery-step">
              <span className="recovery-step-number">1</span>
              <div className="recovery-step-content">
                <h4>Save this emergency recovery key</h4>
                <p>
                  If you lose access to your phone, you won&apos;t be able to log in to your
                  account without this key. Print, copy, or write it down somewhere private.
                </p>
              </div>
            </div>

            <div className="recovery-key-box">
              <code className="recovery-key">{recoverSecret}</code>
            </div>

            <div className="recovery-actions">
              <Button
                variant="outlined"
                color="secondary"
                className={option === "copy" ? "is-selected" : ""}
                onClick={_copyRecoveryKey}
              >
                Copy Key
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                className={option === "print" ? "is-selected" : ""}
                onClick={() => {
                  handlePrint();
                  setOption("print");
                }}
              >
                Print
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                className={option === "wroteDown" ? "is-selected" : ""}
                onClick={() => setOption("wroteDown")}
              >
                I Wrote It Down
              </Button>
            </div>

            <div className="recovery-warning">
              <strong>2. Seriously, save this key!</strong>
              <p>Store it somewhere safe. Anyone with this key can access your account.</p>
            </div>

            <div className="recovery-footer">
              <Button
                color="primary"
                disabled={!option}
                onClick={() => setRecoveryModal(false)}
              >
                Saved, Let&apos;s Finish
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {/* Create key Modal */}
      {OpenCreateKeyModal && (
        <Modal
          title="Create A New Emergency Key"
          className="create-key-modal"
          visible={OpenCreateKeyModal}
          size="large"
          onClose={() => setOpenCreateKeyModal(false)}
        >
          {/* <h3>Create a New Emergency Key</h3> */}
          <p>Once you create a new key, your existing Emergency Recovery Key will Remove.</p>

          <div className="d-flex justify-content-center mt-30">
            <Button
              type="submit"
              color="primary"
              className="submit-button"
              onClick={() => setRecoveryModal(true)}
            >
              Create Key
            </Button>
            <Button
              variant="text"
              color="secondary"
              className="cancel-button"
              onClick={() => setOpenCreateKeyModal(false)}
            >
              Cancel
            </Button>
          </div>
        </Modal>
      )}
    </div >
  );
};

export default SecurityLogin;
